import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  BuildingStorefrontIcon,
  ShoppingBagIcon,
  TagIcon,
  ClipboardDocumentListIcon,
  StarIcon,
  BanknotesIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';

const AdminLayout = ({ children }) => {
  const location = useLocation();

  const navigation = [
    { name: 'لوحة التحكم', href: '/admin/dashboard', icon: HomeIcon },
    { name: 'المستخدمين', href: '/admin/users', icon: UsersIcon },
    { name: 'البائعين', href: '/admin/vendors', icon: BuildingStorefrontIcon },
    { name: 'المنتجات', href: '/admin/products', icon: ShoppingBagIcon },
    { name: 'الطلبات', href: '/admin/orders', icon: ClipboardDocumentListIcon },
    { name: 'الفئات', href: '/admin/categories', icon: TagIcon },
    { name: 'المراجعات', href: '/admin/reviews', icon: StarIcon },
    { name: 'التسويات المالية', href: '/admin/settlements', icon: BanknotesIcon },
    { name: 'الإعدادات', href: '/admin/settings', icon: Cog6ToothIcon },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar for desktop */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col lg:pt-16">
        <div className="flex flex-col flex-grow bg-white border-l border-gray-200 pt-5 pb-4 overflow-y-auto">
          <div className="flex items-center flex-shrink-0 px-4">
            <img 
              src="/logo-small.png" 
              alt="أمازول" 
              className="h-10 w-auto ml-2"
            />
            <h2 className="text-xl font-bold text-gray-900">لوحة الإدارة</h2>
          </div>
          <nav className="mt-5 flex-1 px-2 space-y-1">
            {navigation.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.href);
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`
                    group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors
                    ${active
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                    }
                  `}
                >
                  <Icon
                    className={`
                      ml-3 flex-shrink-0 h-6 w-6
                      ${active ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}
                    `}
                  />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Mobile navigation */}
      <div className="lg:hidden bg-white border-b border-gray-200 sticky top-16 z-40">
        <div className="overflow-x-auto">
          <nav className="flex space-x-reverse space-x-4 px-4 py-3">
            {navigation.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.href);
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`
                    flex flex-col items-center min-w-max px-3 py-2 text-xs font-medium rounded-md transition-colors
                    ${active
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-50'
                    }
                  `}
                >
                  <Icon className="h-6 w-6 mb-1" />
                  <span className="whitespace-nowrap">{item.name}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Main content */}
      <div className="lg:pr-64">
        <main className="pt-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
